(function () {
    'use strict';

    //Vartdal pakkseddel: p2_reportdef_keyno = 19 , navn: VartdalPlastPakkSeddel1.trdp
    //Vartdal pakkseddel: p2_reportdef_keyno = 22 , navn: VartdalPlastPakkSeddel3Copies.trdp

    const module = angular.module('imApp');

    module.component('consignmentPlansConsignmentContent', {
        templateUrl: 'views/components/views/consignmentPlansConsignmentContent/consignmentPlansConsignmentContent.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', '$uibModal', 'stateService', 'utilityService', 'translateService', 'ieScreenBlockService', 'modalService', 'consignmentPlansConsignmentContentService', 'rememberService', 'dbPrinterService', 'printPreviewService', 'printService', 'consignmentPlansOrdersService', function ($stateParams, $uibModal, stateService, utilityService, translateService, ieScreenBlockService, modalService, consignmentPlansConsignmentContentService, rememberService, dbPrinterService, printPreviewService, printService, consignmentPlansOrdersService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let consignmentKeyno = $stateParams.consignment_keyno;
            let custactNo = $stateParams.custact_no;
            let resizing = false;
            let editing = true;

            let variableNames = {
                labour_no: '',
                labour_name: '',
                printer: ''
            };

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                isLast: '0',
                showComplete: 0,
                stockLocationNameButtons: [
                    { id: 'goto', icon: 'glyphicon glyphicon-search', color: 'primary', type: 'primary', onClick: () => saveTemporaryQuantities(() => { stateService.go('consignmentplansdeliverylocation') }) }
                ],
                mconfig: {
                    enabled: true,
                    show: true,
                    activate: function (item) {
                        if (item === 'all') {
                            vm.model.mconfig.records.forEach(function (data) {
                                if (data) {
                                    if (data.canActive === true) {
                                        data.isActive = true;
                                    }
                                }
                            });
                        } else if (item && item.item_id) {
                            vm.model.mconfig.records[item.item_id].isActive = false;
                        } else if (item) {
                            for (let r = 0; r < vm.model.mconfig.records.length; r++) {
                                if (vm.model.mconfig.records[r].item_name === item && vm.model.mconfig.records[r].canActive === true) {
                                    vm.model.mconfig.records[r].isActive = true;
                                    break;
                                }
                            }
                        }
                    },
                    deactivate: function (item) {
                        if (item === 'all') {
                            vm.model.mconfig.records.forEach(function (data) {
                                if (data) {
                                    if (data.item_name === 'resize' && data.isActive) resizeColumns();

                                    if (data.canActive === true) {
                                        data.isActive = false;
                                    }
                                }
                            });
                        } else if (item && item.item_id) {
                            vm.model.mconfig.records[item.item_id].isActive = false;
                        } else if (item) {
                            for (let r = 0; r < vm.model.mconfig.records.length; r++) {
                                if (vm.model.mconfig.records[r].item_name === item) {
                                    vm.model.mconfig.records[r].isActive = false;
                                    break;
                                }
                            }
                        }
                    },
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }

                        if (item.item_name === 'details') stateService.go('consignment', { consignment_keyno: consignmentKeyno });
                        if (item.item_name === 'menu') stateService.go('consignmentplansdelivery');

                        if (item.item_name === 'edit') {
                            if (item.isActive === false) {
                                saveTemporaryQuantities(function () {
                                    loadContents();
                                });
                            }
                        }

                        /* RESIZING COLUMNS */
                        if (item.item_name === 'resize') {
                            if (item.isActive) {
                                resizing = true;
                            } else {
                                resizeColumns();
                            }
                        }
                    },
                    records: [
                        { item_id: '0', item_name: 'option', glyph: 'glyphicon-option-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, enabled: true, show: false },
                        { item_id: '2', item_name: 'plus', glyph: 'glyphicon-plus', color: 'primary', show: false },
                        { item_id: '3', item_name: 'minus', glyph: 'glyphicon-minus', color: 'primary', show: false },
                        //{ item_id: '4', item_name: 'trash', glyph: 'glyphicon-trash', color: 'primary', show: false },
                        //{ item_id: '5', item_name: 'sort', glyph: 'glyphicon-sort', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: true, show: false },
                        { item_id: '5', item_name: 'menu', glyph: 'glyphicon-align-justify', color: 'primary', enabled: true, show: true },
                        { item_id: '6', item_name: 'details', glyph: 'glyphicon-new-window', color: 'primary', enabled: false, show: true },
                        { item_id: '7', item_name: 'resize', glyph: 'glyphicon-resize-horizontal', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: false, show: true },
                        { item_id: '8', item_name: 'edit', glyph: 'glyphicon-edit', color: 'primary', colorActive: 'warning', canActive: true, isActive: false, isIcon: false, enabled: false, show: true },
                        { item_id: '9', item_name: 'check', glyph: 'glyphicon-check', color: 'primary', show: false },
                        { item_id: '10', item_name: 'uncheck', glyph: 'glyphicon-unchecked', color: 'primary', show: false },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: true }
                    ]
                },
                delivery_note: '',
                order_internal_no: 0,
                driver_button_label: '',
                stocklocation_keyno: 0,
                stocklocation_name: '',
                labour_no: '',
                labour_name: '',
                printer: 0,
                reportdef_keyno: 0,
                reportdef_keyno_waybill: 0,
                selectListLabours: [],
                selectListPrinters: [],
                itemsListContents: [],
                lockedPrint: false,
                lockedModus: false,
                lockedComplete: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                const info = (await consignmentPlansConsignmentContentService.getSetting({ consignment_keyno: consignmentKeyno }));

                vm.model.order_internal_no = info.order_internal_no;
                vm.model.driver_button_label = info.delivery_button_label;
                vm.model.printer = info.printer;
                vm.model.labour_no = info.labour_no;
                vm.model.labour_name = info.labour_name;
                vm.model.stocklocation_keyno = info.stocklocation_keyno;
                vm.model.stocklocation_name = info.stocklocation_name;
                vm.model.reportdef_keyno = info.reportdef_keyno;
                vm.model.reportdef_keyno_waybill = info.reportdef_keyno_waybill;
                vm.model.delivery_note = info.delivery_note;
                vm.model.delivery_information = info.delivery_information;
            }

            async function loadLabours() {
                vm.model.selectListLabours = await consignmentPlansConsignmentContentService.listLabours();
            }

            async function loadPrinters() {
                vm.model.selectListPrinters = await dbPrinterService.list();

                vm.model.selectListPrinters.push({
                    item_id: '9999999999',
                    item_name: 'debug no print'
                });
            }

            async function loadContents() {
                ieScreenBlockService.start('message');
                ieScreenBlockService.setMessage('Laster informasjon');

                const list = await consignmentPlansConsignmentContentService.listContents({ consignment_keyno: consignmentKeyno });

                let smallDataLoad = [];

                for (let i = 0; i < list.length; i++) {
                    if (i === 0) {
                        vm.model.isLast = list[i].is_last;
                    }

                    list[i].item_id = illegalCharRegExp(list[i].item_id);
                    smallDataLoad.push(list[i]);
                }

                vm.model.itemsListContents = smallDataLoad;
                    
                ieScreenBlockService.stop();
                validateContents();
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    switch (key) {
                        case 'labour_no':
                        case 'labour_name':
                        case 'printer':
                            variableNames[key] = 'consignmentplansdelivery' + '.' + key;
                            break;
                        default:
                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                            break;
                    }
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'labour_no':
                    case 'labour_name':
                    case 'printer':
                        if (utilityService.validateParmsValue(vm.model[id]) !== true) return;

                        variableValue = vm.model[id];
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region REGULAR EXPRESSION FUNCTION

            function illegalCharRegExp(str) {
                return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "-");
            }

            // #endregion REGULAR EXPRESSION FUNCTION

            // #region VALIDATE CONTENT LIST FUNCTION

            function validateContents() {
                let errorLines = 1;
                vm.model.showComplete = 0;

                if (vm.model.itemsListContents.length > 1) {
                    errorLines = 0;
                }

                if (errorLines === 0) {
                    vm.model.showComplete = 1;
                }
            }

            // #endregion VALIDATE CONTENT LIST FUNCTION

            // #region FIND OBJECT IN LIST FUNCTION

            function findObjectInList(list, key, value) {
                let index = list.findIndex(obj => obj?.[key] === value);

                return { index: index, data: list[index] };
            }

            // #endregion FIND OBJECT IN LIST FUNCTION

            // #region SAVE TEMPORARY QUANTITIES FUNCTION

            function saveTemporaryQuantities(callback) {
                ieScreenBlockService.start('message');
                ieScreenBlockService.setMessage('Lagrer antall');

                let selectedRows = [];

                vm.model.itemsListContents.forEach((item) => {
                    if (item.item_id > 0) {
                        selectedRows.push({
                            ordered_quantity: item.item_secondary[2].item_col,
                            consignmentline_keyno: item.item_id,
                            item_is_selected: item.item_is_selected,
                            cancel_rest: item.item_secondary[6].item_col
                        });
                    }
                });

                rememberService.remember('consignmentplansdeliverycontent.' + consignmentKeyno + '.delivery_note', vm.model.delivery_note).then(() => {
                    consignmentPlansConsignmentContentService.temporaryQuantities({ records: selectedRows }).then((response) => {
                        ieScreenBlockService.stop();

                        if (response[0] && response[0].error_code !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].error_message,
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-warning',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                    }
                                }]
                            });
                        } else {
                            if (callback) {
                                callback();
                            }
                        }
                    });
                });
            }

            // #endregion SAVE TEMPORARY QUANTITIES FUNCTION

            // #region RESIZE COLUMNS FUNCTION

            function resizeColumns() {
                for (let m = 0; m < vm.model.mconfig.records.length; m++) {
                    if (vm.model.mconfig.records[m] && vm.model.mconfig.records[m].item_id === '99') {
                        vm.model.mconfig.records[m].animate = true;
                        break;
                    }
                }

                let updateList = [];

                if (vm.model.itemsListContents[0] && vm.model.itemsListContents[0].item_secondary) {
                    for (let r = 0; r < vm.model.itemsListContents[0].item_secondary.length; r++) {
                        if (r === 0) {
                            updateList.push({
                                item_id: r,
                                item_col_width: vm.model.itemsListContents[0].item_col_width
                            })
                        }

                        if (vm.model.itemsListContents[0].item_secondary[r]) {
                            updateList.push({
                                item_id: r + 1,
                                item_col_width: vm.model.itemsListContents[0].item_secondary[r].item_col_width
                            })
                        }
                    }
                }

                consignmentPlansOrdersService.updateColumnResize({
                    view_id: 'consignmentplansconsignmentcontent.list',
                    records: updateList
                }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                }
                            }]
                        });
                    } else {
                        for (var m = 0; m < vm.model.mconfig.records.length; m++) {
                            if (vm.model.mconfig.records[m] && vm.model.mconfig.records[m].item_id === '99') {
                                vm.model.mconfig.records[m].animate = false;
                                break;
                            }
                        }

                        setTimeout(() => {
                            vm.model.mconfig.records[m].animate = null;
                        }, 2000);
                    }

                    resizing = false;
                });
            }

            // #endregion RESIZE COLUMNS FUNCTION

            // #region CHANGE DRIVER FUNCTION

            vm.changeDriver = function () {
                saveTemporaryQuantities(function () {
                    stateService.go('consignmentplansdeliverydriver', {
                        argtype: 'order',
                        argvalue: vm.model.order_internal_no
                    });
                });
            };

            // #endregion CHANGE DRIVER FUNCTION

            // #region BUTTON SWITCH MODUS PROCEDURE FUNCTION CALL

            vm.updateModus = function () {
                vm.model.lockedModus = true;

                consignmentPlansConsignmentContentService.switchModus({
                    consignment_keyno: consignmentKeyno,
                    item_is_selected: '0'
                }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedModus = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedModus = false;
                        loadContents();
                    }
                });
            };

            // #endregion BUTTON SWITCH MODUS PROCEDURE FUNCTION CALL

            // #region PRINT PICK LIST FUNCTION

            vm.printPickList = function () {
                vm.model.lockedPrint = true;

                let modalInstance = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    component: 'ttConfirm',
                    resolve: {
                        message: function () {
                            return '';
                        }
                    }
                });

                modalInstance.result.then(function (confirmed) {
                    if (confirmed !== true) {
                        vm.model.lockedPrint = false;
                        return;
                    }

                    ieScreenBlockService.start();

                    consignmentPlansConsignmentContentService.printReport({
                        order_internal_no: vm.model.order_internal_no,
                        p2_printer_keyno: vm.model.printer
                    }).then((response) => {
                        vm.model.lockedPrint = false;
                        ieScreenBlockService.stop();

                        if (response[0] && response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-warning',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                    }
                                }]
                            });
                        } else {
                            modalService.show({
                                type: 'success',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-success',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                    }
                                }]
                            });
                        }
                    });
                });
            };

            // #endregion PRINT PICK LIST FUNCTION

            // #region COMPLETE DELIVERY FUNCTION

            vm.complete = function (withWayBill) {
                vm.model.lockedComplete = true;
                let confirmationModal = null;
                const dates = new Set();

                for (let i = 1; i < vm.model.itemsListContents.length; i++) {
                    let line = vm.model.itemsListContents[i];

                    if (line.item_is_selected === '1') {
                        dates.add(line.item_secondary[5].item_col);
                    }
                };

                if (dates.size === 1) {
                    confirmationModal = {
                        type: 'info',
                        title: 'Bekreft',
                        message: 'Er du sikker på at du vil fullføre disse linjene?',
                        okLabel: translations.confirm_ok_label,
                        cancelLabel: translations.confirm_cancel_label
                    };
                } else {
                    confirmationModal = {
                        type: 'danger',
                        title: 'Advarsel',
                        message: 'Det er flere forskjellige leveringsdatoer på linjene du har valgt.  Skal disse virkelig leveres nå?',
                        okLabel: translations.confirm_ok_label,
                        cancelLabel: translations.confirm_cancel_label
                    };
                }

                modalService.confirm(confirmationModal).then(() => {
                    if (vm.model.isLast === '1') {
                        if (vm.model.printer > 0) {
                            // If printer equals the special value: no printing, just complete delivery.
                            if (vm.model.printer === 9999999999) {
                                rememberFunc('printer');
                                ieScreenBlockService.start('message');
                                ieScreenBlockService.setMessage('Fullfører valgte linjer uten utskrift');

                                let selectedRows = [];

                                vm.model.itemsListContents.forEach(function (item) {
                                    if (item.item_id > 0) {
                                        selectedRows.push({
                                            ordered_quantity: item.item_secondary[2].item_col,
                                            consignmentline_keyno: item.item_id,
                                            cancel_rest: item.item_secondary[6].item_col
                                        });
                                    }
                                });

                                consignmentPlansConsignmentContentService.completeDelivery({
                                    test: '',
                                    delivery_note: vm.model.delivery_note,
                                    records: selectedRows
                                }).then(function () {
                                    vm.model.lockedComplete = false;
                                    ieScreenBlockService.setMessage('Printing');
                                    ieScreenBlockService.setMessage('Printing completed');
                                    ieScreenBlockService.stop();
                                    stateService.go('consignmentplansdelivery');
                                });
                            } else {
                                // Regular printing branch
                                rememberFunc('printer');
                                ieScreenBlockService.start('message');
                                ieScreenBlockService.setMessage('Fullfører valgte linjer');

                                let selectedRows = [];

                                vm.model.itemsListContents.forEach(function (item) {
                                    if (item.item_id > 0) {
                                        selectedRows.push({
                                            ordered_quantity: item.item_secondary[2].item_col,
                                            consignmentline_keyno: item.item_id,
                                            cancel_rest: item.item_secondary[6].item_col
                                        });
                                    }
                                });

                                consignmentPlansConsignmentContentService.completeDelivery({
                                    test: '',
                                    delivery_note: vm.model.delivery_note,
                                    records: selectedRows
                                }).then(function () {
                                    let reportKeyno = vm.model.reportdef_keyno;
                                    return printPreviewService.loadP2ReportDef(reportKeyno);
                                }).then(function (response) {
                                    let reportDefinitions = response[0];
                                    ieScreenBlockService.setMessage('Printing');

                                    let parms = {
                                        reportKeyno: reportDefinitions.printserver_keyno,
                                        printerKeyno: vm.model.printer,
                                        parameters: {
                                            consignment_keyno: consignmentKeyno
                                        },
                                        printerProperties: {
                                            isLandscape: reportDefinitions.isLandscape,
                                            pageAutoSize: true,
                                            copies: 1
                                        }
                                    };

                                    if (reportDefinitions.paper_size_id === 'custom') {
                                        parms.printerProperties.pageAutoSize = false;
                                        parms.printerProperties.scale = 'none';

                                        parms.printerProperties.paperSize = {
                                            width: reportDefinitions.width,
                                            height: reportDefinitions.height
                                        };
                                    }

                                    return printService.print(parms).then(function () {
                                        // Check if we also need to print a waybill.
                                        if (withWayBill === true) {
                                            let reportKeynoWaybill = vm.model.reportdef_keyno_waybill;

                                            return printPreviewService.loadP2ReportDef(reportKeynoWaybill).then(function (response) {
                                                let reportDefinitionsWaybill = response[0];
                                                ieScreenBlockService.setMessage('Printing waybill');

                                                let parmsWaybill = {
                                                    reportKeyno: reportDefinitionsWaybill.printserver_keyno,
                                                    printerKeyno: vm.model.printer,
                                                    parameters: {
                                                        consignment_keyno: consignmentKeyno
                                                    },
                                                    printerProperties: {
                                                        isLandscape: reportDefinitionsWaybill.isLandscape,
                                                        pageAutoSize: true,
                                                        copies: 1
                                                    }
                                                };

                                                if (reportDefinitionsWaybill.paper_size_id === 'custom') {
                                                    parmsWaybill.printerProperties.pageAutoSize = false;
                                                    parmsWaybill.printerProperties.scale = 'none';

                                                    parmsWaybill.printerProperties.paperSize = {
                                                        width: reportDefinitionsWaybill.width,
                                                        height: reportDefinitionsWaybill.height
                                                    };
                                                }

                                                return printService.print(parmsWaybill);
                                            });
                                        }
                                    });
                                }).then(function () {
                                    vm.model.lockedComplete = false;
                                    ieScreenBlockService.setMessage('Printing completed');
                                    ieScreenBlockService.stop();
                                    stateService.go('consignmentplansdelivery');
                                });
                            }
                        } else {
                            modalService.show({
                                type: 'danger',
                                title: 'Printer ikke valgt',
                                message: 'Printer ikke valgt',
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-warning',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                    }
                                }]
                            });
                        }
                    } else {
                        ieScreenBlockService.start('message');
                        ieScreenBlockService.setMessage('Fullfører valgte linjer');

                        let selectedRows = [];

                        vm.model.itemsListContents.forEach(function (item) {
                            if (item.item_id > 0) {
                                selectedRows.push({
                                    ordered_quantity: item.item_secondary[2].item_col,
                                    consignmentline_keyno: item.item_id
                                });
                            }
                        });

                        consignmentPlansConsignmentContentService.completeDelivery({
                            test: '',
                            delivery_note: vm.model.delivery_note,
                            records: selectedRows
                        }).then(function () {
                            vm.model.lockedComplete = false;
                            ieScreenBlockService.stop();

                            if (custactNo > 0) {
                                stateService.go('consignmentplansconsignments', { custact_no: custactNo });
                            } else {
                                stateService.go('consignmentplansdelivery');
                            }
                        });
                    }
                }, () => vm.model.lockedComplete = false);
            };

            // #endregion COMPLETE DELIVERY FUNCTION

            // #region ON CHANGE FUNCTIONS

            vm.onLabourerChange = function (value) {
                let selectedItem = findObjectInList(vm.model.selectListLabours, 'item_id', value);

                if (selectedItem?.data?.item_name) {
                    vm.model.labour_no = selectedItem.data.item_id;
                    vm.model.labour_name = selectedItem.data.item_name;

                    rememberFunc('labour_no');
                    rememberFunc('labour_name');
                }
            };

            vm.onPrinterChanged = function (value) {
                vm.model.printer = value;

                if (value) {
                    rememberFunc('printer');
                }
            };

            // #endregion ON CHANGE FUNCTIONS

            // #region TOGGLE CHOSEN FUNCTION

            vm.toggleChosen = function (item) {
                if (item.item_id === '0' || item.item_id === '-1') return;

                if (item.item_is_selected === '0') {
                    item.item_is_selected = '1';
                    item.item_secondary[2].item_col = item.item_secondary[3].item_col;
                } else if (item.item_is_selected === '1') {
                    item.item_is_selected = '0';
                    item.item_secondary[2].item_col = '0.00';
                }
            };

            // #endregion TOGGLE CHOSEN FUNCTION

            // #region ANGULAR CYCLE FUNCTION

            vm.$onInit = function () {
                translate();
                loadSetting();
                loadLabours();
                loadPrinters();
                loadContents();
            };

            // #endregion ANGULAR CYCLE FUNCTION

        }]
    });
})();
